import React from "react";

const Play = () => (
  <svg width="90" height="90" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="45" cy="45" r="44.25" stroke="white" strokeWidth="1.5"/>
<path d="M62.5937 45.0024L35.5938 64.7877L35.5938 25.2171L62.5937 45.0024Z" fill="white"/>
</svg>
);

export default Play;
